// eslint-disable-next-line import/no-anonymous-default-export
export default {
    CertidaoNegativa: 1,
    ProrrogacaoPrazo: 2,
    VistaEletronica: 3,
    Outros: 9
}